import React from 'react';

const HeroSection = (user) => {
  return (
    <div>
      <div
        id="carouselExampleIndicators"
        className="carousel slide container"
        data-bs-ride="true"
      >
        <div className="p-2 fs-3 mb-3">
          Selamat datang, <span className="name-home">{user.user.name}</span>
        </div>
        <div className="carousel-indicators">
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="0"
            class="active"
            aria-current="true"
            aria-label="Slide 1"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="1"
            aria-label="Slide 2"
          ></button>
          <button
            type="button"
            data-bs-target="#carouselExampleIndicators"
            data-bs-slide-to="2"
            aria-label="Slide 3"
          ></button>
        </div>
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img
              src="https://media.istockphoto.com/photos/skillful-worker-attending-brief-meeting-in-the-factory-picture-id1299734004?k=20&m=1299734004&s=612x612&w=0&h=D-BL9fEAdswgKUXfpsVBIQGadUVEMoVXMqB4VzZxrOU="
              className="d-block w-100"
              alt="..."
            />
            <div className="carousel-caption d-none d-md-block">
              <h1>Find Works With Us</h1>
            </div>
          </div>
          <div className="carousel-item">
            <img
              src="https://media.istockphoto.com/photos/young-creative-business-people-meeting-at-office-picture-id1205709428?k=20&m=1205709428&s=612x612&w=0&h=RaJ7tJ62qxTW56e30llq4RMGbiGER7DGavlVYghtax4="
              className="d-block w-100"
              alt="..."
            />
            <div className="carousel-caption d-none d-md-block">
              <h1>Make Better Life</h1>
            </div>
          </div>
          <div className="carousel-item">
            <img
              src="https://media.istockphoto.com/photos/successful-business-team-smiling-teamwork-corporate-office-colleague-picture-id1188452509?k=20&m=1188452509&s=612x612&w=0&h=bg9XjAMR2zwIjXFEDLOb7EIKK76RP5RjR5cCLY1sUNQ="
              className="d-block w-100"
              alt="..."
            />
            <div className="carousel-caption d-none d-md-block">
              <h1>Find Works With Us</h1>
            </div>
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default HeroSection;
